/* 検索件数コンポーネント */
import React, { memo } from 'react';
import { number_of_search_init } from '../../Const';
var NumberOfsearchesList = function (_a) {
    var history = _a.history;
    var history_list = history !== null ? history : number_of_search_init;
    return (React.createElement("div", { className: "my-2" },
        React.createElement("div", { className: "col-md-3 col-sm-3 number-of-searches-list" }, history_list.map(function (item, index) { return (React.createElement("dl", { key: index },
            React.createElement("dt", null, item.key),
            React.createElement("dd", null,
                item.value,
                "\u4EF6"))); }))));
};
export default memo(NumberOfsearchesList);
